interface AccessItem {
  PATH: string;
  KEY: number;
  TITLE: string;
  METHOD: string;
}

export const BRANCHDENIEDROUTES: AccessItem[] = [
  {
    PATH: "/branch/role/create-role",
    KEY: 1,
    TITLE: "Create Role",
    METHOD: "POST",
  },
  {
    PATH: "/branch/role/update-role/:id",
    KEY: 2,
    TITLE: "Update Role",
    METHOD: "PATCH",
  },
  {
    PATH: "/branch/role/get-role/:id",
    KEY: 3,
    TITLE: "Get Role By Id",
    METHOD: "GET",
  },
  {
    PATH: "/branch/role/get-roles",
    KEY: 4,
    TITLE: "Get Roles",
    METHOD: "GET",
  },
  {
    PATH: "/branch/role/delete-role/:id",
    KEY: 5,
    TITLE: "Delete Role",
    METHOD: "DELETE",
  },
  {
    PATH: "/branch/role/activate-role/:id",
    KEY: 6,
    TITLE: "Activate Role",
    METHOD: "PATCH",
  },

  // === EMPLOYEE ===
  {
    PATH: "/branch/employee/get-employees",
    METHOD: "GET",
    TITLE: "Get Employees",
    KEY: 6,
  },
  {
    PATH: "/branch/employee/get-employee/:id",
    METHOD: "GET",
    TITLE: "Get Employee by ID",
    KEY: 7,
  },
  {
    PATH: "/branch/employee/create-employee",
    METHOD: "POST",
    TITLE: "Create Employee",
    KEY: 8,
  },
  {
    PATH: "/branch/employee/update-employee/:id",
    METHOD: "PATCH",
    TITLE: "Update Employee",
    KEY: 9,
  },
  {
    PATH: "/branch/employee/update-employee-password/:id",
    METHOD: "PATCH",
    TITLE: "Update Employee Password",
    KEY: 86,
  },
  {
    PATH: "/branch/employee/delete-employee/:id",
    METHOD: "DELETE",
    TITLE: "Delete Employee",
    KEY: 10,
  },
  {
    PATH: "/branch/employee/activate-employee/:id",
    METHOD: "PATCH",
    TITLE: "Activate Employee",
    KEY: 87,
  },

  // === CATEGORY ===
  {
    PATH: "/branch/category/get-categories",
    METHOD: "GET",
    TITLE: "Get Categories",
    KEY: 11,
  },
  {
    PATH: "/branch/category/get-category/:id",
    METHOD: "GET",
    TITLE: "Get Category by ID",
    KEY: 12,
  },
  {
    PATH: "/branch/category/create-category",
    METHOD: "POST",
    TITLE: "Create Category",
    KEY: 13,
  },
  {
    PATH: "/branch/category/update-category/:id",
    METHOD: "PATCH",
    TITLE: "Update Category",
    KEY: 14,
  },
  {
    PATH: "/branch/category/delete-category/:id",
    METHOD: "DELETE",
    TITLE: "Delete Category",
    KEY: 15,
  },
  {
    PATH: "/branch/category/active-category/:id",
    METHOD: "PATCH",
    TITLE: "Activate Category",
    KEY: 88,
  },

  // === SUBCATEGORY ===
  {
    PATH: "/branch/subcategory/get-subcategories",
    METHOD: "GET",
    TITLE: "Get Subcategories",
    KEY: 16,
  },
  {
    PATH: "/branch/subcategory/get-subcategory/:id",
    METHOD: "GET",
    TITLE: "Get Subcategory by ID",
    KEY: 17,
  },
  {
    PATH: "/branch/subcategory/create-subcategory",
    METHOD: "POST",
    TITLE: "Create Subcategory",
    KEY: 18,
  },
  {
    PATH: "/branch/subcategory/update-subcategory/:id",
    METHOD: "PATCH",
    TITLE: "Update Subcategory",
    KEY: 19,
  },
  {
    PATH: "/branch/subcategory/delete-subcategory/:id",
    METHOD: "DELETE",
    TITLE: "Delete Subcategory",
    KEY: 20,
  },
  {
    PATH: "/branch/subcategory/activate-subcategory/:id",
    METHOD: "PATCH",
    TITLE: "Ativate Subcategory",
    KEY: 89,
  },

  // === BRAND ===
  {
    PATH: "/branch/brand/get-brands",
    METHOD: "GET",
    TITLE: "Get Brands",
    KEY: 92,
  },
  {
    PATH: "/branch/brand/get-brand/:id",
    METHOD: "GET",
    TITLE: "Get Brand by ID",
    KEY: 93,
  },
  {
    PATH: "/branch/brand/create-brand",
    METHOD: "POST",
    TITLE: "Create Brand",
    KEY: 94,
  },
  {
    PATH: "/branch/brand/update-brand/:id",
    METHOD: "PATCH",
    TITLE: "Update Brand",
    KEY: 95,
  },
  {
    PATH: "/branch/brand/delete-brand/:id",
    METHOD: "DELETE",
    TITLE: "Delete Brand",
    KEY: 96,
  },
  {
    PATH: "/branch/brand/activate-brand/:id",
    METHOD: "PATCH",
    TITLE: "Activate Brand",
    KEY: 97,
  },

  // === TAX ===
  { PATH: "/branch/tax/get-taxes", METHOD: "GET", TITLE: "Get Taxes", KEY: 21 },
  {
    PATH: "/branch/tax/get-tax/:id",
    METHOD: "GET",
    TITLE: "Get Tax by ID",
    KEY: 22,
  },
  {
    PATH: "/branch/tax/create-tax",
    METHOD: "POST",
    TITLE: "Create Tax",
    KEY: 23,
  },
  {
    PATH: "/branch/tax/update-tax/:id",
    METHOD: "PUT",
    TITLE: "Update Tax",
    KEY: 24,
  },
  {
    PATH: "/branch/tax/delete-tax/:id",
    METHOD: "DELETE",
    TITLE: "Delete Tax",
    KEY: 25,
  },

  // === SERVICE CHARGE ===
  {
    PATH: "/branch/service-charge/get-service-charges",
    METHOD: "GET",
    TITLE: "Get Service Charges",
    KEY: 26,
  },
  {
    PATH: "/branch/service-charge/get-service-charge/:id",
    METHOD: "GET",
    TITLE: "Get Service Charge by ID",
    KEY: 27,
  },
  {
    PATH: "/branch/service-charge/create-service-charge",
    METHOD: "POST",
    TITLE: "Create Service Charge",
    KEY: 28,
  },
  {
    PATH: "/branch/service-charge/update-service-charge/:id",
    METHOD: "PUT",
    TITLE: "Update Service Charge",
    KEY: 29,
  },
  {
    PATH: "/branch/service-charge/delete-service-charge/:id",
    METHOD: "DELETE",
    TITLE: "Delete Service Charge",
    KEY: 30,
  },

  // === ITEM ===
  {
    PATH: "/branch/item/get-items",
    METHOD: "GET",
    TITLE: "Get Items",
    KEY: 31,
  },
  {
    PATH: "/branch/item/get-item/:id",
    METHOD: "GET",
    TITLE: "Get Item by ID",
    KEY: 32,
  },
  {
    PATH: "/branch/item/create-item",
    METHOD: "POST",
    TITLE: "Create Item",
    KEY: 33,
  },
  {
    PATH: "/branch/item/update-item/:id",
    METHOD: "PUT",
    TITLE: "Update Item",
    KEY: 34,
  },
  {
    PATH: "/branch/item//update-item-price/:id",
    METHOD: "PATCH",
    TITLE: "Update Item Price",
    KEY: 90,
  },
  {
    PATH: "/branch/item/delete-item/:id",
    METHOD: "DELETE",
    TITLE: "Delete Item",
    KEY: 35,
  },

  // === SUPPLIER ===
  {
    PATH: "/branch/supplier/get-supplier",
    METHOD: "GET",
    TITLE: "Get Suppliers",
    KEY: 41,
  },
  {
    PATH: "/branch/supplier/get-supplier/:id",
    METHOD: "GET",
    TITLE: "Get Supplier by ID",
    KEY: 42,
  },
  {
    PATH: "/branch/supplier/create-supplier",
    METHOD: "POST",
    TITLE: "Create Supplier",
    KEY: 43,
  },
  {
    PATH: "/branch/supplier/update-supplier/:id",
    METHOD: "PUT",
    TITLE: "Update Supplier",
    KEY: 44,
  },
  {
    PATH: "/branch/supplier/delete-supplier/:id",
    METHOD: "DELETE",
    TITLE: "Delete Supplier",
    KEY: 45,
  },
  {
    PATH: "/branch/supplier/supplier-invoices/:id",
    METHOD: "GET",
    TITLE: "Get Supplier Invoices",
    KEY: 451,
  },
  {
    PATH: "/branch/supplier/pay-total",
    METHOD: "POST",
    TITLE: "Pay Supplier Total Outstanding",
    KEY: 452,
  },

  // === CUSTOMER ===
  {
    PATH: "/branch/customer/get-customers",
    METHOD: "GET",
    TITLE: "Get Customers",
    KEY: 46,
  },
  {
    PATH: "/branch/customer/get-customer/:id",
    METHOD: "GET",
    TITLE: "Get Customer by ID",
    KEY: 47,
  },
  {
    PATH: "/branch/customer/create-customer",
    METHOD: "POST",
    TITLE: "Create Customer",
    KEY: 48,
  },
  {
    PATH: "/branch/customer/update-customer/:id",
    METHOD: "PUT",
    TITLE: "Update Customer",
    KEY: 49,
  },
  {
    PATH: "/branch/customer/delete-customer/:id",
    METHOD: "DELETE",
    TITLE: "Delete Customer",
    KEY: 50,
  },

  // // === BATCH NUMBER ===
  // { PATH: "/branch/batchnumber/get-batchnumbers", METHOD: "GET", TITLE: "Get Batch Numbers", KEY: 51 },
  // { PATH: "/branch/batchnumber/get-batchnumber/:id", METHOD: "GET", TITLE: "Get Batch Number by ID", KEY: 52 },
  // { PATH: "/branch/batchnumber/create-batchnumber", METHOD: "POST", TITLE: "Create Batch Number", KEY: 53 },
  // { PATH: "/branch/batchnumber/update-batchnumber/:id", METHOD: "PUT", TITLE: "Update Batch Number", KEY: 54 },
  // { PATH: "/branch/batchnumber/delete-batchnumber/:id", METHOD: "DELETE", TITLE: "Delete Batch Number", KEY: 55 },

  // === PURCHASE ===
  {
    PATH: "/branch/purchase/get-purchases",
    METHOD: "GET",
    TITLE: "Get Purchases",
    KEY: 56,
  },
  {
    PATH: "/branch/purchase/get-purchase/:id",
    METHOD: "GET",
    TITLE: "Get Purchase by ID",
    KEY: 57,
  },
  {
    PATH: "/branch/purchase/get-invoice-purchase/:id",
    METHOD: "GET",
    TITLE: "Get Purchase by invoice ID",
    KEY: 91,
  },
  {
    PATH: "/branch/purchase/create-purchase",
    METHOD: "POST",
    TITLE: "Create Purchase",
    KEY: 58,
  },
  // { PATH: "/branch/purchase/delete-purchase/:id", METHOD: "DELETE", TITLE: "Delete Purchase", KEY: 60 },

  // === PURCHASE PAYMENT ===
  {
    PATH: "/branch/purchase-payment/get-purchase-payments",
    METHOD: "GET",
    TITLE: "Get Purchase Payments",
    KEY: 61,
  },
  {
    PATH: "/branch/purchase-payment/get-purchase-paymentsByIVN",
    METHOD: "GET",
    TITLE: "Get Purchase Payment by Invoice",
    KEY: 61,
  },
  {
    PATH: "/branch/purchase-payment/get-invoice-purchase-payments/:id",
    METHOD: "GET",
    TITLE: "Get Purchase Payment by ID",
    KEY: 62,
  },

  // === STOCK ===
  {
    PATH: "/branch/stock/get-stocks",
    METHOD: "GET",
    TITLE: "Get Stocks",
    KEY: 66,
  },
  {
    PATH: "/branch/stock/get-stock/:id",
    METHOD: "GET",
    TITLE: "Get Stock by ID",
    KEY: 67,
  },
  {
    PATH: "/branch/stock/create-stock",
    METHOD: "POST",
    TITLE: "Create Stock",
    KEY: 68,
  },
  {
    PATH: "/branch/stock/update-stock/:id",
    METHOD: "PUT",
    TITLE: "Update Stock",
    KEY: 69,
  },
  {
    PATH: "/branch/stock/delete-stock/:id",
    METHOD: "DELETE",
    TITLE: "Delete Stock",
    KEY: 70,
  },

  // === TRANSFER ===
  {
    PATH: "/branch/transfer/get-transfers",
    METHOD: "GET",
    TITLE: "Get Transfers",
    KEY: 71,
  },
  {
    PATH: "/branch/transfer/get-transfer/:id",
    METHOD: "GET",
    TITLE: "Get Transfer by ID",
    KEY: 72,
  },
  {
    PATH: "/branch/transfer/create-transfer",
    METHOD: "POST",
    TITLE: "Create Transfer",
    KEY: 73,
  },
  {
    PATH: "/branch/transfer/update-transfer/:id",
    METHOD: "PUT",
    TITLE: "Update Transfer",
    KEY: 74,
  },
  {
    PATH: "/branch/transfer/delete-transfer/:id",
    METHOD: "DELETE",
    TITLE: "Delete Transfer",
    KEY: 75,
  },

  // === LOYALTY ===
  {
    PATH: "/branch/loyalty/get-loyalties",
    METHOD: "GET",
    TITLE: "Get Loyalties",
    KEY: 81,
  },
  {
    PATH: "/branch/loyalty/get-loyalty/:id",
    METHOD: "GET",
    TITLE: "Get Loyalty by ID",
    KEY: 82,
  },
  {
    PATH: "/branch/loyalty/create-loyalty",
    METHOD: "POST",
    TITLE: "Create Loyalty",
    KEY: 83,
  },
  {
    PATH: "/branch/loyalty/update-loyalty/:id",
    METHOD: "PUT",
    TITLE: "Update Loyalty",
    KEY: 84,
  },
  {
    PATH: "/branch/loyalty/delete-loyalty/:id",
    METHOD: "DELETE",
    TITLE: "Delete Loyalty",
    KEY: 85,
  },
];
export default BRANCHDENIEDROUTES;
